module.exports = __webpack_public_path__ + "img/settle-inbounds.5511af46.png";